import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar: React.FC = () => {
  const { currentUser, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  const handleAnalyticsClick = (e: React.MouseEvent) => {
    if (!currentUser) {
      e.preventDefault();
      setShowLoginPrompt(true);
      setTimeout(() => setShowLoginPrompt(false), 3000);
    }
  };

  return (
    <>
      <nav className="bg-gray-800 shadow-lg">
        <div className="container mx-auto flex justify-between items-center p-4">
          <Link to="/" className="text-2xl font-bold text-white hover:text-[#f47521] transition-colors">
            Shot Speed Tracker
          </Link>
          
          <div className="flex items-center space-x-6">
            {currentUser ? (
              <>
                {isAdmin && (
                  <Link to="/tracker" className="text-white hover:text-[#f47521] transition-colors">
                    Tracker
                  </Link>
                )}
                <Link to="/" className="text-white hover:text-[#f47521] transition-colors">
                  Leaderboard
                </Link>
                <Link to="/analytics" className="text-white hover:text-[#f47521] transition-colors">
                  Analytics
                </Link>
                <Link to="/credits" className="text-white hover:text-[#f47521] transition-colors">
                  Credits
                </Link>
                <button
                  onClick={handleLogout}
                  className="bg-[#f47521] text-white hover:bg-[#ff8534] px-4 py-2 rounded transition-colors"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/" className="text-white hover:text-[#f47521] transition-colors">
                  Leaderboard
                </Link>
                <Link 
                  to="/analytics" 
                  className="text-white hover:text-[#f47521] transition-colors"
                  onClick={handleAnalyticsClick}
                >
                  Analytics
                </Link>
                <Link to="/credits" className="text-white hover:text-[#f47521] transition-colors">
                  Credits
                </Link>
                <Link 
                  to="/login" 
                  className="bg-[#f47521] text-white hover:bg-[#ff8534] px-4 py-2 rounded transition-colors"
                >
                  Login
                </Link>
              </>
            )}
          </div>
        </div>
      </nav>
      
      {showLoginPrompt && !currentUser && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 bg-[#f47521] text-white px-6 py-3 rounded shadow-lg z-50">
          Please login to view analytics
        </div>
      )}
    </>
  );
};

export default Navbar; 